import { render, staticRenderFns } from "./box-add-or-update.vue?vue&type=template&id=feb39e88&"
import script from "./box-add-or-update.vue?vue&type=script&lang=js&"
export * from "./box-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports